<script setup lang="ts">
import merge from 'lodash-es/merge';
import { useWebsitesStore } from '../../../pages/cms/management/websites/_runtime/stores/websites';
import type { FormSettings } from '../custom-menu/CustomMenuSettings.vue';

defineOptions({
    name: 'SaleReportsSettings'
});

const props = defineProps<{
    modelValue: any;
}>();
const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const module = ref('sale-reports');
const defaults = ref<any>({
    page: null
});

const form = computed<FormType<FormSettings>>(() =>
{
    return props.modelValue;
});

const current = computed<CurrentWebsite>(() =>
{
    return useWebsitesStore().current;
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    await wait(() => current.value.website);
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Strona dokumentów rozliczeniowych]]]')" :invalid-feedback="form.$errors.first('settings.pageId')" :state="form.$errors.state('settings.pageId')">
        <EditoPageSelector v-model="form.settings.pageId" :module="module" label="" :preview="false" class="mb-0" />
    </IdeoFormGroup>
</template>
